import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { ListItem, Collapse, Link } from '@material-ui/core'
import menuOptions from '../../assets/menuOptions.json'
import './NavItem.scss'

const NavItem = () => {
    let navigate = useNavigate()
    const handler = children => {
        return children.map( subOption => {
            const iconClass = `c-light-blue-500 ${subOption.icon}`
            if ( !subOption.children ) {
                const isExternal = subOption.url.startsWith('http')
                return isExternal ? (<a href={ subOption.url } target='_blank' className='sidebar-link'>
                          <span className='icon-holder'>
                            <i className={ iconClass }></i>
                          </span>
                        <span className='title'>{ subOption.title }</span>
                    </a>) : (
                    <Link to={ subOption.url } onClick={() => navigate(subOption.url)}>
                        <a className='sidebar-link'>
                          <span className='icon-holder'>
                            <i className={ iconClass }></i>
                          </span>
                          <span className='title'>{ subOption.title }</span>
                        </a>
                    </Link>
                )
            }
            return (<></>
                // <ListItem
                //     style={{paddingLeft: '25px'}}
                //     button
                //     onClick={ () => handleClick( subOption ) }
                // >
                //     <a className='sidebar-link inner'>
                //         <span className='icon-holder'>
                //           <i className={ iconClass }></i>
                //         </span>
                //         <span className='title'>{ subOption.title }</span>
                //         <Collapse
                //             in={ state[subOption.title] }
                //             timeout='auto'
                //             unmountOnExit
                //         >
                //             { this.handler (subOption.children )}
                //         </Collapse>
                //     </a>
                // </ListItem>
            )
        })
    }
    return (
        <li className='nav-item mT-30 active'>
            { handler(menuOptions.data) }
        </li>
    )
}

export default NavItem
